// product grid/list
function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', function () {
      // Null-guard the grid lookup once - page may not have a product-grid (cart, account, etc.) when this script runs.
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
      this.classList.add('active');
      if (this.classList.contains('listv')) {
        grid.classList.add('product-list');
        grid.classList.remove('product-grid');
        grid.classList.remove('product-gallery');
        if (window.innerWidth < 768) {
          const gridv = document.querySelector('.gridv');
          if (gridv) gridv.classList.remove('active_mobile');
        }
      } else if (this.classList.contains('gridv')) {
        grid.classList.add('product-grid');
        grid.classList.remove('product-list');
        grid.classList.remove('product-gallery');
      } else if (this.classList.contains('galleryv')) {
        grid.classList.add('product-gallery');
        grid.classList.remove('product-list');
        grid.classList.remove('product-grid');
      }
    });
  });
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();


// Throttle helper - limits function calls to once per delay ms
function throttle(fn, delay) {
  let lastCall = 0;
  let scheduled = false;
  return function(...args) {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      fn.apply(this, args);
    } else if (!scheduled) {
      scheduled = true;
      setTimeout(() => {
        scheduled = false;
        lastCall = Date.now();
        fn.apply(this, args);
      }, delay - (now - lastCall));
    }
  };
}

// on scroll play video - optimized with throttle
// Cache video elements to avoid repeated DOM queries
let cachedVideoElements = null;
let videoObserver = null;

function initVideoScroll() {
  cachedVideoElements = document.querySelectorAll('video[autoplay]');
  if (cachedVideoElements.length === 0) return;
  
  // Use IntersectionObserver for better performance (GPU accelerated)
  if ('IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play().catch(() => {});
        } else {
          entry.target.pause();
        }
      });
    }, { threshold: 0.5 });
    
    cachedVideoElements.forEach(video => videoObserver.observe(video));
  } else {
    // Fallback for old browsers - throttled scroll
    window.addEventListener('scroll', throttle(videoScrollFallback, 150), { passive: true });
  }
}

function videoScrollFallback() {
  if (!cachedVideoElements || cachedVideoElements.length === 0) return;
  const windowHeight = window.innerHeight;
  
  cachedVideoElements.forEach(video => {
    const rect = video.getBoundingClientRect();
    const videoHeight = rect.height;
    if (rect.top <= windowHeight - videoHeight * 0.5 && rect.top >= -videoHeight * 0.5) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  });
}

if (typeof requestIdleCallback === 'function') { requestIdleCallback(initVideoScroll, { timeout: 3000 }); }
else { window.addEventListener('load', initVideoScroll); }

// timer - OPTIMIZED: Cache DOM elements, only run if countdowns exist
// Helper function to format number with leading zeros
function formatTime(num) {
  return num.toString().padStart(2, '0');
}

// Helper function to update countdown value with animation
function updateCountdownValue(element, newValue, oldValue) {
  if (!element) return;
  
  // Only animate and update if value changed
  if (newValue !== oldValue) {
    element.classList.add('changing');
    element.textContent = formatTime(newValue);
    
    // Remove animation class after animation completes
    setTimeout(() => {
      element.classList.remove('changing');
    }, 500);
  }
}

// Cached countdown data with pre-queried DOM elements
let cachedCountdowns = null;
let countdownInterval = null;

function initCountdowns() {
  const sections = document.querySelectorAll('.countd_all');
  if (sections.length === 0) {
    // No countdowns on page - don't start interval
    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }
    return;
  }
  
  // Cache all countdown sections with their DOM elements (query once, use forever).
  // Skip sections without data-date so we don't throw on `null.replaceAll`.
  cachedCountdowns = Array.from(sections).reduce(function (acc, section) {
    var raw = section.getAttribute('data-date');
    if (!raw) return acc;
    var targetDate = new Date(raw.replaceAll('-', '/')).getTime();
    if (isNaN(targetDate)) return acc;
    acc.push({
      section: section,
      targetDate: targetDate,
      elements: {
        days: section.querySelector('.main_cdays .wb_cdays'),
        hours: section.querySelector('.main_chours .wb_chours'),
        minutes: section.querySelector('.main_cminutes .wb_cminutes'),
        seconds: section.querySelector('.main_cseconds .wb_cseconds')
      },
      state: { days: null, hours: null, minutes: null, seconds: null }
    });
    return acc;
  }, []);
  
  // Run immediately
  countDown();
  
  // Start interval only if not already running
  if (!countdownInterval) {
    countdownInterval = setInterval(countDown, 1000);
    // Pause when tab hidden to save CPU/battery
    if (!window.__countdownVisibilityBound) {
      window.__countdownVisibilityBound = true;
      document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        } else if (!countdownInterval && cachedCountdowns && cachedCountdowns.length > 0) {
          countDown();
          countdownInterval = setInterval(countDown, 1000);
        }
      });
    }
  }
}

function countDown() {
  if (!cachedCountdowns || cachedCountdowns.length === 0) return;
  
  const now = Date.now();
  
  cachedCountdowns.forEach(countdown => {
    const distance = countdown.targetDate - now;
    const { elements, state } = countdown;
    
    if (distance < 0 || isNaN(countdown.targetDate)) {
      updateCountdownValue(elements.days, 0, state.days);
      updateCountdownValue(elements.hours, 0, state.hours);
      updateCountdownValue(elements.minutes, 0, state.minutes);
      updateCountdownValue(elements.seconds, 0, state.seconds);
      state.days = 0;
      state.hours = 0;
      state.minutes = 0;
      state.seconds = 0;
    } else {
      const days = Math.floor(distance / 86400000); // 1000 * 60 * 60 * 24
      const hours = Math.floor((distance % 86400000) / 3600000); // 1000 * 60 * 60
      const minutes = Math.floor((distance % 3600000) / 60000); // 1000 * 60
      const seconds = Math.floor((distance % 60000) / 1000);
      
      updateCountdownValue(elements.days, days, state.days);
      updateCountdownValue(elements.hours, hours, state.hours);
      updateCountdownValue(elements.minutes, minutes, state.minutes);
      updateCountdownValue(elements.seconds, seconds, state.seconds);
      
      state.days = days;
      state.hours = hours;
      state.minutes = minutes;
      state.seconds = seconds;
    }
  });
}

// Initialize countdown on load
document.addEventListener('DOMContentLoaded', initCountdowns);
// Re-init when Shopify sections are loaded (for theme editor)
document.addEventListener('shopify:section:load', () => {
  cachedCountdowns = null;
  initCountdowns();
});